// Cuánto tapa el teclado desde abajo. En iOS el WebView NO achica el layout viewport al abrir
// el teclado (lo tapa por encima), así que una caja al pie de una pantalla de alto fijo queda
// debajo del teclado. Lo usan el panel del chat y la conversación del Asistente de Crear en el
// teléfono (review atlas-code#179), para correr su pie lo que mide el teclado.

import { useEffect, useState } from 'react';

/** `activo` en false: no escucha nada y devuelve 0 (el panel cerrado, la computadora). */
export function useAltoDelTeclado(activo = true): number {
  const [alto, setAlto] = useState(0);
  useEffect(() => {
    if (!activo || typeof window === 'undefined') return;
    const vv = window.visualViewport;
    if (!vv) return;
    const medir = () => {
      const tapa = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      // Umbral de 120px: reaccionamos al teclado, no a las barras del navegador que
      // aparecen y desaparecen al scrollear.
      setAlto(tapa > 120 ? tapa : 0);
    };
    medir();
    vv.addEventListener('resize', medir);
    vv.addEventListener('scroll', medir);
    return () => {
      vv.removeEventListener('resize', medir);
      vv.removeEventListener('scroll', medir);
      setAlto(0);
    };
  }, [activo]);
  return alto;
}
